(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_faq"] && !window.DesignMode) return;
  try {
    
      // Product Page FAQ Section
    window.onload = function() {
    let FaqData = document.querySelectorAll(".faqBlock .Item");

    FaqData.forEach(function(item) {
      let title = item.querySelector("h3").textContent;
      let desc = item.querySelector("p").innerHTML;

      let collapsible = document.createElement("div");
      collapsible.classList.add("Collapsible");

      let button = document.createElement("button");
      button.classList.add("Collapsible__Button", "Heading", "u-h6");
      button.setAttribute("data-action", "toggle-collapsible");
      button.setAttribute("aria-expanded", "false");
      button.textContent = title;

      let span = document.createElement("span");
      span.classList.add("Collapsible__Plus");
      button.appendChild(span);

      let innerDiv = document.createElement("div");
      innerDiv.classList.add("Collapsible__Inner");

      let contentDiv = document.createElement("div");
      contentDiv.classList.add("Collapsible__Content");
      contentDiv.innerHTML = desc;

      innerDiv.appendChild(contentDiv);
      collapsible.appendChild(button);
      collapsible.appendChild(innerDiv);

      document.querySelector(".faqSection .faqBlock").appendChild(collapsible);
      item.parentNode.removeChild(item);
    });

    // Add event listener for toggling collapsible elements
    let collapsibleButtons = document.querySelectorAll("[data-action='toggle-collapsible']");

    collapsibleButtons.forEach(function(button) {
      button.addEventListener("click", function() {
        let collapsibleInner = this.nextElementSibling;
        let expanded = this.getAttribute("aria-expanded");

        if (expanded === "true") {
          collapsibleInner.style.visibility = "hidden";
          collapsibleInner.style.height = "0";
          this.setAttribute("aria-expanded", "false");
        } else {
          // Hide other open collapsibles before expanding this one
          let openCollapsibles = document.querySelectorAll(".Collapsible__Inner[style*='visible']");

          openCollapsibles.forEach(function(collapsible) {
            collapsible.style.visibility = "hidden";
            collapsible.style.height = "0";
            collapsible.previousElementSibling.setAttribute("aria-expanded", "false");
          });

          collapsibleInner.style.visibility = "visible";
          collapsibleInner.style.height = "auto";
          this.setAttribute("aria-expanded", "true");
        }
      });
    });
  };

  } catch(e) { console.error(e); }
})();
})();
